import Lottie from 'react-lottie';
import animationData from '../lottie/Confetti.json';

const LottieScoreAnimation = ({ style, loop = false, autoplay = true }) => {
  const defaultOptions = {
    loop,
    autoplay,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div style={style}>
      <Lottie options={defaultOptions} />
    </div>
  );
};

export default LottieScoreAnimation;
